import { observable, action, runInAction } from 'mobx';
import { isEmpty } from 'lodash';

const moHome = observable({
  videoUrl: '',
  isOpen: false,
});

const homeInit = action(() => {
  console.log('home init');
});

const toggleOpen = action((value: boolean) => {
  moHome.isOpen = value;
});

const setUrl = action((value: string) => {
  moHome.videoUrl = value;
});

export default moHome;
export { homeInit, toggleOpen, setUrl };
